import { render, staticRenderFns } from "./TablePlug.vue?vue&type=template&id=75372e54&scoped=true&"
import script from "./TablePlug.vue?vue&type=script&lang=js&"
export * from "./TablePlug.vue?vue&type=script&lang=js&"
import style0 from "./TablePlug.vue?vue&type=style&index=0&id=75372e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75372e54",
  null
  
)

export default component.exports